import React, { useState, useCallback, useContext, useEffect } from 'react';
import axios from 'axios';
import { transformIframes } from '../../../utils/utils';
import styles from './styles/ChoicesBody.module.css';
import HintModal from './HintModal';
import { useScenario } from '../../../context/ScenarioContext';
import socket from './../../../socket'
import { useParams } from 'react-router-dom';

const ChoicesBody = ({
    choices,
    scenario,
    setCurrentSituationId,
    isScenarioLogged,
    preview,
    userKeys,
    setUserKeys,
    userId,
    assignmentId,
    userInfo,
}) => {
    const [showHintModal, setShowHintModal] = useState(false);
    const [hintText, setHintText] = useState('');
    const [isProcessing, setIsProcessing] = useState(false);
    const { addDecisionToLog, currentSituations } = useScenario();
    //console.log(userId);
    useEffect(() => {
        if (assignmentId) {
            //console.log("emitting", currentSituations, scenario);
            socket.emit('studentProgressUpdate', { studentId: userId, studentName:userInfo.username, studentEmail:userInfo.email, situationId: currentSituations?.[scenario._id], assignmentId});
            //console.log(currentSituations);
        }
    },[assignmentId]);
    
    const handleClickChoice = useCallback(async (choice) => {
        if (isProcessing) return;
        setIsProcessing(true);

        let grantedNewKeys = false;

        try {
            if (choice.grantsKeys && choice.grantsKeys.length > 0) {
                const newKeysToGrant = choice.grantsKeys.filter(key => !userKeys.includes(key));
                if (newKeysToGrant.length > 0) {
                    grantedNewKeys = true;
                    if (userId) {
                        await axios.patch(
                            `${process.env.REACT_APP_API_URL_LOCAL}/api/users/${userId}/grantKeys`,
                            { keys: newKeysToGrant },
                            { withCredentials: true }
                        );
                    }
                    setUserKeys(prevKeys => [...new Set([...prevKeys, ...newKeysToGrant])]);
                }
            }
            console.log("adding ", isScenarioLogged);
            if (isScenarioLogged && !preview) {
                const decisionObject = {
                    type: 'choice',
                    id: choice._id,
                    title: choice.title,
                };
                
                await addDecisionToLog(decisionObject, assignmentId, false);
            }


            if (choice.hasHint && choice.situation === choice.nextSituation._id) {
                setHintText(choice.hint);
                setShowHintModal(true);
            } else if (choice.nextSituation?._id) {
                //const situationId = choice.nextSituation._id;
                //console.log("Assignment Id", assignmentId);
                //console.log("next id", choice.nextSituation._id);
                if (assignmentId) {
                    socket.emit('studentProgressUpdate', { studentId: userId, studentName:userInfo.username, studentEmail:userInfo.email, situationId: choice.nextSituation._id, assignmentId});
                }
                setCurrentSituationId(choice.nextSituation._id);
            } else {
                console.warn("Choice has no next situation and is not a self-referencing hint:", choice);
            }

        } catch (error) {
            console.error("Error processing choice:", error);
        } finally {
            setTimeout(() => setIsProcessing(false), 0);
        }
    }, [
        isProcessing, 
        userKeys, 
        userId, 
        setUserKeys, 
        isScenarioLogged, 
        preview, 
        addDecisionToLog, 
        setCurrentSituationId,
        assignmentId,
    ]);

    const closeModal = useCallback(() => {
        setShowHintModal(false);
        setHintText('');
    }, []);

    const isChoiceVisible = useCallback((choice) => {
        if (!choice.key) {
            return true;
        }
        const hasKey = userKeys.includes(choice.key);
        if (choice.showIfKey) {
            return hasKey;
        } else if (choice.hideIfKey) {
            return !hasKey;
        }
        return true;
    }, [userKeys]);

    // Memoize filteredChoices if choices or userKeys can changes too frequently and filtering is expensive.
    // For typical scenarios, this might be overkill but I'm going to leave it here for the future.
    // const filteredChoices = useMemo(() => choices.filter(isChoiceVisible), [choices, isChoiceVisible]);
    const filteredChoices = choices.filter(isChoiceVisible);


    return (
        <>
            <div className={styles.container}>
                {filteredChoices.map((choice) => (
                    <div
                        key={choice._id}
                        role="button"
                        tabIndex={0}
                        className={`
                            ${styles.choice} 
                            ${isProcessing ? styles.disabledChoice : ''}
                        `}
                        onClick={() => handleClickChoice(choice)}
                        onKeyPress={(e) => e.key === 'Enter' && handleClickChoice(choice)}
                        dangerouslySetInnerHTML={{ __html: transformIframes(choice.text) }}
                        aria-disabled={isProcessing}
                    />
                ))}
            </div>

            {showHintModal && (
                <HintModal hintText={hintText} closeModal={closeModal} />
            )}
        </>
    );
};

export default ChoicesBody;